module.exports = __webpack_public_path__ + "static/media/2010s-Automotive-Icon.7a6c4672.png";